import React, { forwardRef } from 'react';
import { Button } from '#components/button/button.tsx';
import { useThemeStrings } from '#hooks/use-theme.ts';
import { GDSCustomizableComponent } from '#src/types.ts';

interface GDSComposableCardDismissButtonProps extends GDSCustomizableComponent {
  onDismiss: (event: React.MouseEvent) => void;
  dismissButtonLabel?: string;
  isFloatingButton?: boolean;
}

const getButtonStyles = (isFloatingButton: boolean) =>
  isFloatingButton
    ? {
        position: 'absolute',
        insetBlockStart: '$half',
        insetInlineEnd: '$half',
        zIndex: 2,
      }
    : { alignSelf: 'end' };

export const ComposableCardDismissButton = forwardRef<
  HTMLButtonElement,
  GDSComposableCardDismissButtonProps
>(
  (
    {
      'data-testid': testId = `GDS-ComposableCard-DismissButton`,
      onDismiss,
      dismissButtonLabel,
      isFloatingButton = false,
      css,
    },
    ref,
  ) => {
    const strings = useThemeStrings();

    const buttonStyles = getButtonStyles(isFloatingButton);

    return (
      <Button
        data-testid={testId}
        className="GDS-composable-card-dismiss-button"
        hideLabel
        icon="interfaceClose"
        priority="secondary"
        onClick={onDismiss}
        quiet
        size="small"
        css={{
          ...buttonStyles,
          ...css,
        }}
        ref={ref}
      >
        {dismissButtonLabel || strings.dismiss}
      </Button>
    );
  },
);
